import { GET_MEDIA_KEY } from '@/pages/AdvancedEditor/hooks';
import { deleteMedia } from '@/services/api';
import { useMutation, useQueryClient } from 'react-query';

export const useMediaDelete = () => {
    const queryClient = useQueryClient();

    return useMutation(deleteMedia, {
        onSuccess: () => {
            queryClient.invalidateQueries(GET_MEDIA_KEY);
        },
    });
};
